import { useEffect } from 'react';
import { MODAL_WINDOW_CLASSNAME, SPA_ROOT_ID } from '@yme/atoms/modal-window/constants';
export const useFocusTrap = (ref) => {
    useEffect(() => {
        const spaRoot = document.getElementById(SPA_ROOT_ID);
        if (!spaRoot) {
            return;
        }
        spaRoot.classList.add(MODAL_WINDOW_CLASSNAME);
        spaRoot.setAttribute('aria-hidden', 'true');
        const getFocusableElements = () => {
            return Array.from(ref?.current?.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])') ?? []).filter((el) => el instanceof HTMLElement &&
                !el.hasAttribute('disabled') &&
                !el.hasAttribute('aria-hidden') &&
                el.tabIndex !== -1);
        };
        const handleFocusTrap = (e) => {
            if (e.key !== 'Tab') {
                return;
            }
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) {
                return;
            }
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            const currentIndex = focusableElements.indexOf(document.activeElement);
            if (e.shiftKey) {
                e.preventDefault();
                if (document.activeElement === firstElement || currentIndex < 0) {
                    lastElement.focus();
                }
                else {
                    focusableElements[currentIndex - 1].focus();
                }
            }
            else {
                e.preventDefault();
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                }
                else {
                    focusableElements[currentIndex + 1].focus();
                }
            }
        };
        document.addEventListener('keydown', handleFocusTrap);
        return () => {
            spaRoot.classList.remove(MODAL_WINDOW_CLASSNAME);
            spaRoot.setAttribute('aria-hidden', 'false');
            document.removeEventListener('keydown', handleFocusTrap);
        };
    }, [ref]);
};
